<template>
  <div>
    <app-history @clicked="$router.push('/contacts')" />
    <div class="thumbnails">
      <span v-for="(rec, index) in receiverStack" :key="index">
        <b v-if="index == receiverStack.length - 1">{{ rec.Title }}</b>
        <a v-else @click="sliceArray(index)"><b>{{ rec.Title }}</b></a>
        <span v-if="index != receiverStack.length - 1"> {{ separator }} </span>
      </span>
    </div>
    <div v-if="currentReceiver.Hint != ''" class="fullText fullForm" v-html="currentReceiver.Hint"></div>
    <v-card class="fullForm" v-if="currentReceivers.length > 0">
      <v-row class="receiverRow" v-for="(rec, index) in currentReceivers" :key="rec.Fserial" @click="handleClick(rec)">
        <v-col class="d-flex receiverTitle" cols="10">
          <b>{{ rec.Title }}</b>
        </v-col>
        <v-col class="d-flex receiverIcon">
          <font-awesome-icon icon="angle-left" />
        </v-col>
        <hr v-if="index != currentReceivers.length - 1" />
      </v-row>
    </v-card>
    <v-card class="fullForm" v-else-if="currentReceiver.NeedDescription">
      <v-row>
        <v-col class="d-flex" cols="2" sm="2" lg="1">
          <b> موضوع:</b>
        </v-col>
        <v-col class="d-flex" cols="10" sm="10" lg="11">
          {{ currentReceiver.Title }}
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex" cols="2" sm="2" lg="1">
          <b> گیرنده:</b>
        </v-col>
        <v-col class="d-flex" cols="10" sm="10" lg="11">
          {{ currentReceiver.FullName }}
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>پیام:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-textarea outlined v-model="text" no-resize></v-textarea>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="2" sm="2" md="2" lg="1">
          <b> ضمائم:</b>
        </v-col>
        <v-col style="text-align:right" cols="10" sm="10" md="5" lg="4">
          <v-btn color="#777777" style="color: white" class="text-none" rounded depressed @click="onButtonClick">
            لطفا فایل های خود را ضمیمه فرمایید.
            <v-icon left>
              mdi-camera
            </v-icon>
          </v-btn>
        </v-col>
        <v-col class="d-flex" xs="12" sm="12" md="5" lg="7">
          <v-file-input label="" chips prepend-icon="" v-model="files" v-show="files && files.length > 0" multiple
            ref="uploader" id="uploader"></v-file-input>
        </v-col>
      </v-row>

      <v-row class="ltr">
        <v-col class="d-flex" xs="12" sm="4" md="3">
          <v-btn color="primary white--text" class="ErtebatRegister" rounded @click="applyRequest"
            :disabled="apiRunning">
            {{ apiRunning ? "لطفا منتظر بمانید..." : "ثبت" }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { sendMessage, getReceiversV3, sendMessageV3 } from "@/api/ertebat";
import Receiver from "./Receiver";
import HistoryButton from "@/components/HistoryButton";
export default {
  data() {
    return {
      text: "",
      files: null,
      receiverStack: [
        {
          Fserial: "",
          Parent: "",
          Title: "دسته بندی ها",
          SortOrder: 1,
          NeedDescription: false,
          Hint: "",
          DashboardId: "",
        },
      ],
      separator: " > ",

      receivers: [],
    };
  },
  computed: {
    currentReceiver() {
      return this.receiverStack[this.receiverStack.length - 1];
    },
    currentReceivers() {
      return this.receivers.filter((single) => {
        return single.Parent == this.currentReceiver.Fserial;
      });
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },
  components: {
    appReceiver: Receiver,
    appHistory: HistoryButton,
  },
  watch: {
    // Watch for route changes to handle browser back/forward buttons
    '$route.query': {
      handler(newQuery) {
        this.handleRouteChange(newQuery);
      },
      immediate: true
    }
  },
  created() {
    getReceiversV3().then((response) => {
      this.receivers = response.data;
      // Initialize receiver stack from query params if they exist
      this.initializeFromQueryParams();
    });
  },
  methods: {
    handleClick(rec) {
      // Find the index of the clicked receiver in currentReceivers
      const receiverIndex = this.currentReceivers.findIndex(r => r.Fserial === rec.Fserial);

      if (receiverIndex !== -1) {
        // Build new path array
        const currentPath = this.getCurrentPathFromQuery();
        const newPath = [...currentPath, receiverIndex];

        this.updateUrlWithPath(newPath);
      }
    },

    sliceArray(index) {
      // Slice the path array and update URL
      const currentPath = this.getCurrentPathFromQuery();
      const newPath = currentPath.slice(0, index);
      this.updateUrlWithPath(newPath);
    },

    getCurrentPathFromQuery() {
      // Get path from query params or return empty array
      const pathParam = this.$route.query.path;
      if (!pathParam) return [];

      // Convert "0,1,2" to [0, 1, 2]
      return pathParam.split(',').map(Number).filter(num => !isNaN(num));
    },

    updateUrlWithPath(pathArray) {
      if (pathArray.length === 0) {
        // If no path, remove query params
        this.$router.push({ query: {} });
      } else {
        // Convert array to comma-separated string
        this.$router.push({
          query: {
            path: pathArray.join(',')
          }
        });
      }
    },

    buildStackFromPath(pathArray) {
      let stack = [this.receiverStack[0]]; // Start with root
      let currentReceiversList = this.receivers.filter(r => r.Parent === ""); // Root level receivers

      // Build stack by following the path indices
      for (let i = 0; i < pathArray.length; i++) {
        const index = pathArray[i];

        if (index >= 0 && index < currentReceiversList.length) {
          const receiver = currentReceiversList[index];
          stack.push(receiver);

          // Get next level receivers for the next iteration
          currentReceiversList = this.receivers.filter(r => r.Parent === receiver.Fserial);
        } else {
          // Invalid path index, break out
          console.warn('Invalid path index:', index);
          break;
        }
      }

      return stack;
    },

    initializeFromQueryParams() {
      const pathArray = this.getCurrentPathFromQuery();
      if (pathArray.length > 0) {
        const stack = this.buildStackFromPath(pathArray);
        if (stack.length > 1) {
          this.receiverStack = stack;
        }
      }
    },

    handleRouteChange(queryParams) {
      window.scrollTo(0, 0);
      // Rebuild receiver stack when route changes (browser back/forward)
      const pathArray = this.getCurrentPathFromQuery();
      const stack = this.buildStackFromPath(pathArray);
      this.receiverStack = stack;
    },

    onButtonClick() {
      this.$refs.uploader.$refs.input.click();
    },

    applyRequest() {
      var text = "";
      if (this.text == "") {
        text = "پیام نباید خالی باشد.";
      } else if (this.files != null) {
        var size = 0;
        for (var i = 0; i < this.files.length; i++) {
          size += this.files[i].size;
        }
        if (size > 10 * 1024 * 1024) {
          text = "مجموع حجم ضمائم نباید بیش از 10 مگابایت باشد.";
        }
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);
        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);

        sendMessageV3(this.files, this.currentReceiver.Fserial, this.text)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
            this.$store.commit("SET_API_RUNNING", false);
            if (data.Success) {
              this.goToIndex();
            }
          })
          .catch((error) => {
            this.$store.commit("SET_API_RUNNING", false);
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },

    goToIndex() {
      this.$store.commit("SET_DIALOG_SHOW", false);
      // Clear query parameters when going to contacts
      this.$router.push({
        path: "/contacts",
        query: {}
      });
    },
  },

};
</script>
<style scoped>
@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}

.receiverRow {
  cursor: pointer;
}

hr {
  width: 100%;
}

.receiverTitle {
  margin: 10px 0;
}

.receiverIcon {
  margin: 10px;
  direction: ltr;
}

.thumbnails {
  margin: 30px;
}
</style>
<style>
.ErtebatRegister {
  margin-top: 30px;
  width: 100%;
}
</style>
